import { Link } from "react-router-dom";

const CTASection = ({ localizedPath }: { localizedPath: string }) => (
  <section className="py-16 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <h2 className="text-3xl font-bold text-gray-900 mb-4">
        ¿Listo para tu próxima aventura?
      </h2>

      <p className="text-xl text-gray-600 mb-8">
        Explora nuestras propiedades únicas y encuentra el lugar perfecto para
        tus vacaciones.
      </p>

      <Link
        to={localizedPath}
        className="inline-block bg-brand-primary text-white px-8 py-3 rounded-lg font-semibold hover:bg-brand-primary-hover transition-colors"
      >
        Ver Propiedades
      </Link>
    </div>
  </section>
);

export default CTASection;
